var map = {
	"./public/403.html": "8ccf",
	"./public/favicon.ico": "05fd",
	"./public/fonts/Muyao.min.ttf": "80d7",
	"./public/images/1.png": "835d",
	"./public/images/2.png": "6c69",
	"./public/images/3.png": "1057",
	"./public/images/5.png": "0b36",
	"./public/images/6.png": "226e",
	"./public/images/7.png": "87e9",
	"./public/images/8.png": "7c03",
	"./public/index.html": "cb67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8569";